import { ReactNode } from "react";
import { Breakpoints } from "swing-components";

type ContentSingleColumnProps = {
  children: ReactNode;
};

// TODO: Should be used as the direct child component of the `Page` component
export function ContentSingleColumn(props: ContentSingleColumnProps) {
  const { children } = props;

  return (
    <div
      css={{
        maxWidth: 900,
        margin: "0 auto", // Center the content
        width: "100%",
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,

        [Breakpoints.mediumDeviceAndUp]: {
          paddingTop: 40,
          paddingLeft: 24,
          paddingRight: 24,
        },
      }}
    >
      {children}
    </div>
  );
}
